"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ isEditing }) => {
    return {
        schemaType: "object",
        properties: [
            ...(!isEditing
                ? [
                    {
                        title: "初期E-MAIL",
                        propertyName: "initialEmail",
                        schema: { schemaType: "text", readOnly: isEditing },
                    },
                ]
                : []),
            {
                title: "権限",
                propertyName: "role",
                schema: {
                    schemaType: "selector",
                    options: [
                        {
                            title: "マスター",
                            value: "master",
                        },
                        {
                            title: "プロジェクト",
                            value: "project",
                        },
                    ],
                },
            },
            {
                title: "プロジェクト",
                propertyName: "projectIds",
                schema: {
                    schemaType: "multipleExternalKey",
                    uiType: "normal",
                    resourcePath: "/project",
                    titleKey: "projectName",
                },
            },
            {
                title: "氏名",
                propertyName: "name",
                schema: { schemaType: "text" },
            },
            {
                title: "所属",
                propertyName: "organization",
                schema: { schemaType: "text" },
            },
            {
                title: "エラーコード",
                propertyName: "errorCode",
                schema: { schemaType: "text", readOnly: true },
            },
        ],
    };
};
